module.exports = __webpack_public_path__ + "img/ufro.3f1838cc.jpg";